module.exports = __webpack_public_path__ + "static/media/TN-Men-Pants-v2.0-OA.65a58fbb.svg";